const initState = {
  successFetching: false,
  errorFetching: false,
  type: null,
  value: null,
  date: null,
};

export default initState;
